__turbopack_context__.v({
  "footer": "Footer-module__mBOrwW__footer",
});
